export const moduleName = 'common'
